export default __webpack_public_path__ + "static/media/Redwing-Medium.7402d4c7.otf";